var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-10 mb-5",staticStyle:{"height":"600px"}},[(_vm.statusReady)?[(_vm.statusReady)?_c('ag-charts-vue',{staticClass:"pb-3",attrs:{"options":_vm.barChartOptions}}):_vm._e()]:_c('v-alert',{attrs:{"value":true,"type":"info"}},[_vm._v(" No Bar Chart to display ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }